<template>
  <b-modal
    size="lg"
    v-b-tooltip.hover
    ref="resolveRef"
    @hidden="onResolveCancel"
    :ok-only="resolutionObj.type === 'viewNote'"
    :ok-title="resolutionObj.type === 'viewNote' ? 'Close' : ''"
    :no-close-on-backdrop="resolutionObj.action !== 'view'"
    :no-close-on-esc="resolutionObj.action !== 'view'"
  >
    <div slot="modal-header" class="w-100 d-flex justify-content-between">
      <h5 class="mb-0">
        {{ resolutionObj.title }}
        <span class="notes-date" v-if="resolutionObj.type === 'viewNote' && formData.updated_at">
          {{ dateFormate(getFormattedDate(formData.updated_at, dateTime)) }}
        </span>
      </h5>
    </div>

    <form @submit.stop.prevent="onSubmitResolve">
      <div class="row resolution-container" v-if="isDataExist">
        <div class="col-4">
          <b-card class="h-100">
            Select all Symptoms that apply
            <div v-for="(alert, index) in alerts" :key="index" class="text-break">
              <b-form-checkbox-group
                class="pb-1"
                v-model="formData.symptoms"
                id="symptoms-selector"
                :disabled="resolutionObj.action !== 'add'"
              >
                <b-form-checkbox
                  v-if="resolutionObj.actionType === 'followUp'"
                  :value="alert.id"
                  >{{ isArrayEmpty(alert.symptoms) ? alert.description : alert.symptoms
                   }}</b-form-checkbox
                >
                <b-form-checkbox v-else :value="alert.alert_id">
                  {{ alert.desc.split(":")[0] }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
          </b-card>
        </div>
        <div class="col-8">
          <b-card class="h-100">
            <template slot="header" class="my-2">
              <div label="Resolution template" class="border-bottom pb-3">
                <label label-for="protocal-change">Resolution template</label>
                <b-form-select
                  v-model="selectedProtocol"
                  :options="protocolList"
                  value-field="id"
                  text-field="title"
                  :disabled="isDisableSelect"
                  @change="changeProtocolTemplate"
                ></b-form-select>
              </div>
              <div
                class="row no-gutters pt-3"
                v-if="!isArrayEmpty(formData.protocol.pages)"
              >
                <div
                  v-for="(page, index) in formData.protocol.pages"
                  :key="index"
                  class="pagination-container"
                  @click="currentPageNo = page.pageOrder"
                >
                  <div
                    class="wizard"
                    :class="{ active: page.pageOrder <= currentPage }"
                  ></div>
                </div>
                <div class="ml-auto pt-1">
                  Section {{ currentPage }}/{{
                    formData.protocol.pages && formData.protocol.pages.length
                  }}
                </div>
                <span></span>
              </div>
            </template>

            <div
              v-for="(option, index) in formData.protocol.pages[currentPage - 1]
                .options"
              :key="index"
            >
              <div v-if="option.type === 'checkbox'">
                <b-form-group :label="option.title">
                  <div v-for="item in option.choices" :key="item.title">
                    <b-form-checkbox
                      :value="item.key"
                      :disabled="resolutionObj.action === 'view'"
                      v-model="
                        formData.protocol.pages[currentPage - 1].options[index]
                          .value
                      "
                    >
                      {{ item.title }}
                    </b-form-checkbox>
                  </div>
                </b-form-group>
              </div>
              <div v-if="option.type === 'radio'">
                <b-form-group :label="option.title">
                  <b-form-radio
                    v-for="item in option.choices"
                    :key="item.key"
                    :value="item.title"
                    :disabled="resolutionObj.action === 'view'"
                    v-model="
                      formData.protocol.pages[currentPage - 1].options[index]
                        .value
                    "
                  >
                    {{ item.title }}</b-form-radio
                  >
                </b-form-group>
              </div>
              <div v-if="option.type === 'textarea'">
                <b-form-group :label="option.title">
                  <b-form-textarea
                    :disabled="resolutionObj.action === 'view'"
                    v-model="
                      formData.protocol.pages[currentPage - 1].options[index]
                        .value
                    "
                  >
                  </b-form-textarea>
                </b-form-group>
              </div>
            </div>

            <template slot="footer">
              <div class="row navigation">
                  <span class="px-3">
                    <i :disabled="currentPage === 1" class="fa fa-backward" aria-hidden="true" @click="goBack"></i>
                  </span>
                  <span class="px-3">
                   <i :disabled="currentPage === formData.protocol.pages.length" class="fa fa-forward" aria-hidden="true" 
                    @click="currentPage === formData.protocol.pages.length ? '' : goNext()"></i>
                  </span>

                <b-button
                  variant="primary"
                  class="px-4 ml-auto"
                  @click="goNext(currentPage === formData.protocol.pages.length ? 'saveOnly' : 'save')"
                  v-if="resolutionObj.action !== 'view'"
                  :disabled="isArrayEmpty(formData.symptoms) || isValueEmpty"
                  >{{currentPage == formData.protocol.pages.length ? 'Save' : 'Save & Next'}}</b-button
                >
              </div>
            </template>
          </b-card>
        </div>
      </div>
      <div v-else-if="!isProtocolLoading && !isResolutionLoadingToAlert && !isResolutionLoadingToFollowUp">
        No Data found
      </div>
    </form>
    <div
      slot="modal-footer"
      class="w-100"
      v-if="resolutionObj.type === 'resolve'"
    >
      <b-btn
        size="sm"
        class="float-right"
        variant="primary"
        :disabled="isArrayEmpty(formData.symptoms) || isValueEmpty"
        @click="onSubmitResolve"
      >
        Submit Resolution
      </b-btn>
      <b-btn
        size="sm"
        variant="outline-primary"
        class="float-right btn btn-outline-primary  mr-2"
        @click="onResolveCancel"
      >
        Cancel
      </b-btn>
    </div>
    <v-loader :isLoading="isProtocolLoading || isResolutionLoadingToAlert || isResolutionLoadingToFollowUp"></v-loader>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import Transformer from "@/transformers/ResolutionTransformer";
import VLoader from "@/components/loader/index.vue";
import dateFormate from "@/mixins/dateFormate";

export default {
  name: "Resolution",
  data() {
    return {
      formData: {},
      currentPageNo: 1,
      alerts: [],
      selectedProtocol: "",
      resolutionAlertId: "",
      selectedSymptoms: [],
      isValueExist: false,
      resolutionObj: {
        type: "",
        action: "",
        title: "",
        actionType: ""
      }
    };
  },
  components: {
    VLoader
  },
  mixins: [dateFormate],
  props: {
    onResolve: { type: Function, default: () => {} },
    onFollowUp: { type: Function, default: () => {} }
  },
  watch: {
    managementProtocolTemplate: {
      handler: "fetchProtocolTemplate"
    },
    resolvedNotesToAlert: {
      handler: "fetchNotesToAlert"
    },
    resolvedNotesToFollowUp: {
      handler: "fetchNotesToAlert"
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/getUser",
      protocolList: "managementProtocolTemplate/getProtocolList",
      resolvedAlertIdToAlert: "alert/getResolvedAlertId",
      resolvedAlertIdToFollowUp: "followUps/getResolvedAlertId",
      isProtocolLoading: "managementProtocolTemplate/getLoading",
      isResolutionLoadingToAlert: "alert/getIsResolutionLoading",
      isResolutionLoadingToFollowUp: "followUps/getIsResolutionLoading",
      managementProtocolTemplate:
        "managementProtocolTemplate/getManagementProtocolTemplate",
      resolvedNotesToAlert: "alert/getResolvedNotes",
      resolvedNotesToFollowUp: "followUps/getFollowUpResolvedNotes",
    }),
    currentPage() {
      return this.currentPageNo;
    },
    isDataExist() {
      return this.formData && this.formData.protocol;
    },
    isDisableSelect() {
      if (this.resolutionObj.action === 'add') {
        if (this.resolutionObj.actionType === 'alert' && this.resolvedAlertIdToAlert) {
          return true
        } else if (this.resolutionObj.actionType === 'followUp' && this.resolvedAlertIdToFollowUp) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    isValueEmpty() {
      // eslint-disable-next-line
      this.isValueExist = false;
      this.formData.protocol.pages[this.currentPage - 1].options.map((option) => {
         if(!this.isArrayEmpty(option.value) && !this.isValueExist) {
           // eslint-disable-next-line
           this.isValueExist = true;
           return false;
         }
      });
      return !this.isValueExist;

    }
  },
  beforeMount() {
    if (this.managementProtocolTemplate && this.managementProtocolTemplate.id) {
      this.fetchProtocolTemplate(this.managementProtocolTemplate);
    }
  },
  methods: {
    goBack() {
      if (this.currentPage !== 1) {
        this.currentPageNo -= 1;
      }
    },
    goNext(action) {
      if (this.resolutionObj.action !== "view" && (action === 'save' || action === 'saveOnly')) {
        this.handleFormSubmit();
      }
      if (action !== 'saveOnly') {
        this.currentPageNo += 1;
      }
    },
    fetchProtocolTemplate(data) {
      this.formData = Transformer.getResolutionData(data);
      this.formData.symptoms = this.isArrayEmpty(this.selectedSymptoms)
        ? []
        : this.selectedSymptoms;
      this.selectedProtocol = this.formData.template_id;
      document.documentElement.style.setProperty(
        "--wizardLength",
        this.formData.protocol.pages.length
      );
    },
    fetchNotesToAlert(value) {
      if (!this.isArrayEmpty(value)) {
        this.formData = Transformer.getUpdatedResolutionData(value[0], this.resolutionObj.actionType);
        this.selectedProtocol = this.formData.template_id;
        document.documentElement.style.setProperty(
          "--wizardLength",
          this.formData.protocol.pages.length
        );
        this.alerts = this.resolutionObj.actionType === 'alert' ? value[0].alert : value[0].symptoms;
      }
    },
    showResolvedNotesToAlert(patientDetails) {
      this.resolutionObj.actionType = "alert";
      this.resolutionObj.title = "Resolution Notes";
      this.resolutionObj.action = "view";
      this.resolutionObj.type = "viewNote";
      this.patientDetails = patientDetails;
      this.$refs.resolveRef.show();
    },
    showResolvedNotesToFollowUp(patientDetails) {
      this.resolutionObj.actionType = "followUp";
      this.resolutionObj.title = "Follow Up Notes";
      this.resolutionObj.action = "view";
      this.resolutionObj.type = "viewNote";
      this.patientDetails = patientDetails;
      this.$refs.resolveRef.show();
    },
    showResolutionToAlert(alerts, protocalTemplate, action) {
      this.resolutionObj.actionType = "alert";
      this.resolutionObj.title = action === 'add' ? "Add Resolution" : "Edit Resolution";
      this.resolutionObj.action = action;
      this.resolutionObj.type = "resolve";
      this.$refs.resolveRef.show();
      if (action === "add") {
        this.alerts = alerts;
        this.formData = Transformer.getResolutionData(protocalTemplate);
        this.selectedProtocol = this.formData.template_id;
        document.documentElement.style.setProperty(
          "--wizardLength",
          this.formData.protocol.pages.length
        );
      }
    },
    showResolutionToFollowUp(alerts, protocalTemplate, action) {
      this.resolutionObj.actionType = "followUp";
      this.resolutionObj.title = action === 'add' ? "Add Resolution" : "Edit Resolution";
      this.resolutionObj.action = action;
      this.resolutionObj.type = "resolve";
      this.$refs.resolveRef.show();
      if (action === "add") {
        this.alerts = alerts;
        this.formData = Transformer.getResolutionData(protocalTemplate);
        this.selectedProtocol = this.formData.template_id;
        document.documentElement.style.setProperty(
          "--wizardLength",
          this.formData.protocol.pages.length
        );
      }
    },
    onResolveCancel() {
      this.$refs.resolveRef.hide();
      if (this.resolutionObj.type === "resolve" && !this.formData.isCompleted) {
        this.resolutionObj.actionType === "alert"
          ? this.onResolve()
          : this.onFollowUp();
      }
      this.alerts = [];
      this.formData = {};
      this.currentPageNo = 1;
      this.selectedProtocol = "";
      this.resolutionObj = {};
      this.selectedSymptoms = [];
    },
    changeProtocolTemplate() {
      this.$store.dispatch(
        "managementProtocolTemplate/getManagementProtocolTemplate",
        this.selectedProtocol
      );
      this.selectedSymptoms = this.formData.symptoms;
      this.currentPageNo = 1;
    },
    onSubmitResolve() {
      this.formData.isCompleted = true;
      this.handleFormSubmit();
    },
    handleFormSubmit() {
      if (!this.isArrayEmpty(this.formData.symptoms)) {
        this.formData.signedBy = [{ id: this.currentUser.id }];
        if (this.resolutionObj.action === "add") {
          this.formData.resolved_alert_id = this.resolutionObj.actionType === 'alert' ? this.resolvedAlertIdToAlert :this.resolvedAlertIdToFollowUp
        }
        this.$store.dispatch(
          this.resolutionObj.actionType === "followUp"
            ? "followUps/resolve"
            : "alert/resolve",
          {
            formData: [this.formData],
            isCompleted: this.formData.isCompleted,
            successCb:  this.resolutionObj.actionType === "followUp" ? this.onFollowUp : this.onResolve,
          }
        );
        this.formData.isCompleted ? this.onResolveCancel() : "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
